export const FUTURE_ENTRIES_INDICATOR_PT_BR = {
	futureEntries: "Lançamentos futuros dos próximos",
	days: "{{count}} dias",
	viewFutureEntries: "Ver Lançamentos Futuros",
	futureEntriesTooltip:
		"Valores previstos, como créditos a receber e cobranças que vencem em breve ou que ficaram pendentes por saldo insuficiente.",
};

export type FutureEntriesIndicatorTranslations = typeof FUTURE_ENTRIES_INDICATOR_PT_BR;
